import { createContext, useContext, useState, ReactNode } from 'react';

interface SidebarExtraContextType {
  sidebarExtra: ReactNode | null;
  setSidebarExtra: (content: ReactNode | null) => void;
}

const SidebarExtraContext = createContext<SidebarExtraContextType>({
  sidebarExtra: null,
  setSidebarExtra: () => {},
});

export function SidebarExtraProvider({ children }: { children: ReactNode }) {
  const [sidebarExtra, setSidebarExtra] = useState<ReactNode | null>(null);
  return (
    <SidebarExtraContext.Provider value={{ sidebarExtra, setSidebarExtra }}>
      {children}
    </SidebarExtraContext.Provider>
  );
}

export function useSidebarExtra() {
  return useContext(SidebarExtraContext);
}
